import {NuxtIcon} from "#components";
import {h} from "vue";
import { createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  id: "svg-BP-logo_svg__Layer_1",
  "data-name": "Layer 1",
  viewBox: "0 0 381.86 465.68"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("defs", null, [
      (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode(".svg-BP-logo_svg__cls-1{fill:#10ade4;fill-rule:evenodd}", -1)
        ]))]),
        _: 1
      }))
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("path", {
      id: "svg-BP-logo_svg__Small",
      d: "m66.71 108.24 108.22-54.12s13.42-5.87 0-9.41S45.54 2.36 45.54 2.36 33.89-.12 26.72 0c-7.17.13-11.77 0-11.77 0S-4.18 1.5.84 16.48c5.02 14.97 25.88 84.71 25.88 84.71s12.96 28.97 39.99 7.06Z",
      class: "svg-BP-logo_svg__cls-1"
    }, null, -1)),
    _cache[2] || (_cache[2] = _createElementVNode("path", {
      id: "svg-BP-logo_svg__Medium",
      d: "M113.76 150.59 236.1 80s21.99-9.79 42.35 16.47c20.36 26.26 98.81 129.41 98.81 129.41s19.33 33.43-21.17 18.82-242.32-94.12-242.32-94.12Z",
      style: {"fill":"#4b4b4d","fill-rule":"evenodd"}
    }, null, -1)),
    _cache[3] || (_cache[3] = _createElementVNode("path", {
      id: "svg-BP-logo_svg__Large",
      d: "m94.94 200 251.73 108.23s14.26 4.25 4.7 14.12-134.1 129.41-134.1 129.41-10.33 13.91-28.23 13.91-59.59-14.3-72.93-58.61-54.1-183.53-54.1-183.53-2.89-38.89 32.94-23.53Z",
      class: "svg-BP-logo_svg__cls-1"
    }, null, -1))
  ]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "BP-logo"}) } }